import React, { useRef, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as commentActions from 'Shared/actions/Comments.actions';

import CommentTextEditor from './CommentTextEditor/CommentTextEditor';
import { WorkspaceComment } from 'Shared/types/WorkspaceComment.type';

import CommentListItem from './CommentListItem';

import './Comments.scss';

type Props = {
  handleCreateComment: Function;
  comments: WorkspaceComment[];
  workspaceId: string;
};

const Comments = ({ handleCreateComment, comments, workspaceId }: Props) => {
  const dispatch = useDispatch();

  const isEmpty = comments.length === 0;
  const scrollableAreaElem = useRef(null);

  const handleDeleteComment = useCallback(
    slug => {
      return dispatch(commentActions.deleteComment(slug));
    },
    [commentActions]
  );

  const handleUpdateComment = useCallback(
    data => {
      return dispatch(commentActions.updateComment(data));
    },
    [commentActions]
  );

  useEffect(() => {
    if (!scrollableAreaElem.current) {
      return;
    }
    scrollableAreaElem.current.scrollTop = scrollableAreaElem.current.scrollHeight;
  }, [comments]);

  return (
    <div className="Comments">
      {isEmpty ? (
        <div className="Comments__empty">
          <p>Be the first to add a comment about this goal.</p>
        </div>
      ) : (
        <div className="Comments__list" ref={scrollableAreaElem}>
          {comments.map(comment => (
            <CommentListItem
              key={`comment-${comment.id}`}
              comment={comment}
              handleDeleteComment={handleDeleteComment}
              handleUpdateComment={handleUpdateComment}
              workspaceId={workspaceId}
            />
          ))}
        </div>
      )}
      <div className="Comments__new-input">
        <CommentTextEditor workspaceId={workspaceId} handleCreateComment={handleCreateComment} hideVideo />
      </div>
    </div>
  );
};

export default Comments;
